'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { motion } from 'framer-motion';
import { Image } from '@/components/client';
interface ChipProps {
  className?: string;
  localName?: string;
  specialtyImageUrl?: string;
  isActive?: boolean;
  isRecent?: boolean;
}
export const Chip = t0 => {
  const $ = _c(29);
  const {
    className,
    localName,
    specialtyImageUrl,
    isActive: t1,
    isRecent: t2
  } = t0;
  const isActive = t1 === undefined ? false : t1;
  const isRecent = t2 === undefined ? false : t2;
  const MotionWrapper = isRecent ? motion.div : "div";
  let t3;
  if ($[0] !== isRecent) {
    t3 = isRecent ? {
      animate: {
        y: [0, -8, 0]
      },
      transition: {
        duration: 0.6,
        repeat: Infinity,
        repeatDelay: 1,
        ease: "easeOut"
      }
    } : {};
    $[0] = isRecent;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const motionProps = t3;
  let t4;
  if ($[2] !== className) {
    t4 = cn("relative", className);
    $[2] = className;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== isActive) {
    t5 = isActive && <div className="absolute left-1/2 top-[64px] h-16 w-36 -translate-x-1/2"><svg xmlns="http://www.w3.org/2000/svg" width="35" height="16" viewBox="0 0 35 16" fill="none"><ellipse cx="17.5" cy="8" rx="17.5" ry="8" fill="#DB0101" /></svg></div>;
    $[4] = isActive;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg className="absolute inset-0 size-full" viewBox="0 0 61 75" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M34.71 70.126C32.19 72.08 28.79 72.08 26.27 70.125C21.98 66.8 15.75 61.4 10.61 54.665C5.46 47.91 1.5 39.95 1.5 31.48C1.5 19.68 4.82 12.28 9.92 7.8C15.05 3.29 22.25 1.5 30.49 1.5C38.73 1.5 45.94 3.29 51.07 7.8C56.172 12.28 59.5 19.68 59.5 31.48C59.5 39.955 55.54 47.91 50.38 54.666C45.24 61.41 39.01 66.8 34.71 70.126Z" strokeWidth="3" /></svg>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = isActive ? "#FFF4BE" : "#F0F0F0";
  const t8 = isActive ? "#FFEE98" : "#E5E7EC";
  let t9;
  if ($[7] !== t7 || $[8] !== t8) {
    t9 = <path d="M34.71 70.126C32.19 72.08 28.79 72.08 26.27 70.125C21.98 66.8 15.75 61.4 10.61 54.665C5.46 47.91 1.5 39.95 1.5 31.48C1.5 19.68 4.82 12.28 9.92 7.8C15.05 3.29 22.25 1.5 30.49 1.5C38.73 1.5 45.94 3.29 51.07 7.8C56.172 12.28 59.5 19.68 59.5 31.48C59.5 39.955 55.54 47.91 50.38 54.666C45.24 61.41 39.01 66.8 34.71 70.126Z" fill={t7} stroke={t8} strokeWidth="3" />;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const t10 = isActive ? "#FFF4BE" : "#D1D5DD";
  let t11;
  if ($[10] !== t10) {
    t11 = <path d="M25.1 23.15C24.97 21.42 24.97 17.81 25.1 16.08C26.453 15.98 27.98 15.98 29.21 16.03C36.2 16.3 40 20.09 40 27.12C40 31.73 37.77 35.2 33.84 36.75C33.84 38.39 33.75 40.172 33.62 41.72C31.96 41.91 27.94 41.91 26.37 41.72C26.06 37.94 25.97 33.37 26.15 31.77L27.764 31.64C31.13 31.364 32.53 29.58 32.53 27.17C32.53 24.61 30.78 23.24 28.51 23.15C27.37 23.1 26.41 23.15 25.1 23.15ZM25.579 49.44C25.579 46.88 27.55 44.87 29.99 44.87C32.44 44.87 34.41 46.88 34.41 49.44C34.41 51.992 32.44 54 29.99 54C27.55 54 25.579 51.992 25.579 49.44Z" fill={t10} />;
    $[10] = t10;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t11 || $[13] !== t9) {
    t12 = <svg xmlns="http://www.w3.org/2000/svg" width="61" height="74" viewBox="0 0 61 74" fill="none">{t9}{t11}</svg>;
    $[12] = t11;
    $[13] = t9;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== isActive || $[16] !== isRecent || $[17] !== localName || $[18] !== specialtyImageUrl) {
    t13 = isActive ? <><div className="absolute left-1/2 top-4 size-44 -translate-x-1/2">{specialtyImageUrl ? <div className="relative size-full"><Image src={specialtyImageUrl} alt={`${localName} 특산품 이미지`} fill={true} sizes="44px" className="object-contain" loading="lazy" quality={75} /></div> : <div className="flex size-full items-center justify-center"><svg width="12" height="30" viewBox="0 0 17 44" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.29 7.87C-0.1 5.34 -0.1 1.79 0.29 0.27C1.7 -0.02 2.32 -0.02 3.75 0.03C11.9 0.35 16.36 4.76 16.36 12.94C16.36 18.31 13.75 22.34 9.15 24.13C9.15 26.05 9.04 28.14 8.9 30.03C6.89 30.45 2.26 30.45 0.43 30.03C0.07 25.525 -0.03 20.22 0.17 18.36L2.06 18.2C5.99 17.88 7.62 15.82 7.62 13.0C7.62 10.02 5.56 8.43 2.93 8.32C1.6 8.26 0.48 8.32 0.29 8.32ZM0.68 38.9C0.68 35.92 2.97 33.6 5.82 33.6C8.67 33.6 10.97 35.92 10.97 38.9C10.97 41.88 8.67 44.2 5.82 44.2C2.97 44.2 0.68 41.88 0.68 38.9Z" fill="#DB0101" /></svg></div>}</div><p className={cn("absolute left-1/2 w-56 -translate-x-1/2 whitespace-pre-wrap text-center font-700 text-Gray-700 typo-caption2", "top-44")}>{localName}</p>{isRecent && <div className="absolute right-0 top-0 size-8 rounded-pill bg-O-500" />}</> : <svg className="absolute left-1/2 top-[16px] -translate-x-1/2" width="15" height="40" viewBox="0 0 15 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.1 7.15C-0.03 5.42 -0.03 1.81 0.1 0.08C1.453 -0.02 1.98 -0.02 3.21 0.03C10.2 0.3 14 4.09 14 11.12C14 15.73 11.77 19.2 7.84 20.75C7.84 22.39 7.75 24.172 7.62 25.72C5.96 25.91 1.94 25.91 0.37 25.72C0.06 21.94 -0.03 17.37 0.15 15.77L1.76 15.64C5.13 15.364 6.53 13.58 6.53 11.17C6.53 8.61 4.78 7.24 2.51 7.15C1.37 7.1 0.41 7.15 0.1 7.15ZM0.58 33.44C0.58 30.88 2.55 28.87 4.99 28.87C7.44 28.87 9.41 30.88 9.41 33.44C9.41 35.992 7.44 38 4.99 38C2.55 38 0.58 35.992 0.58 33.44Z" fill="#D1D5DD" /></svg>;
    $[15] = isActive;
    $[16] = isRecent;
    $[17] = localName;
    $[18] = specialtyImageUrl;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t12 || $[21] !== t13) {
    t14 = <div className="relative h-[75px] w-[61px]">{t6}{t12}{t13}</div>;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== MotionWrapper || $[24] !== motionProps || $[25] !== t14 || $[26] !== t4 || $[27] !== t5) {
    t15 = <MotionWrapper className={t4} {...motionProps}>{t5}{t14}</MotionWrapper>;
    $[23] = MotionWrapper;
    $[24] = motionProps;
    $[25] = t14;
    $[26] = t4;
    $[27] = t5;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  return t15;
};